<agr-form-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <span>{{ 'reference-value-sheet.select-country.description' | translate }}</span>
  <div class="flex--column">
    <mat-form-field class="flex__child--auto spacing--margin-top">
      <mat-label>{{ 'reference-value-sheet.select-country.label' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="country"
        data-test="select-country"
      >
        <mat-option *ngFor="let country of data.countries" [value]="country">
          {{ getRefValSheetCountryLabel(country) }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</agr-form-dialog>
